import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertModalService, AlertModalConfig } from '../../services/alert-modal.service';

@Component({
  selector: 'app-alert-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent implements OnInit {
  isVisible = false;
  alertConfig: AlertModalConfig | null = null;

  constructor(private alertModalService: AlertModalService) {}

  ngOnInit(): void {
    this.alertModalService.alert$.subscribe((config) => {
      this.alertConfig = config;
      this.isVisible = config !== null;
    });
  }

  onOk(): void {
    if (this.alertConfig) {
      this.alertModalService.handleOk(this.alertConfig.navigateTo);
    }
  }

  onConfirm(): void {
    if (this.alertConfig?.onConfirm) {
      this.alertConfig.onConfirm();
    }
    this.alertModalService.closeAlert();
  }

  onCancel(): void {
    this.alertModalService.closeAlert();
  }

  getAlertClass(): string {
    switch (this.alertConfig?.type) {
      case 'success':
        return 'alert-success';
      case 'error':
        return 'alert-danger';
      case 'confirm':
        return 'alert-warning';
      default:
        return 'alert-info';
    }
  }

  getIconClass(): string {
    switch (this.alertConfig?.type) {
      case 'success':
        return 'bi bi-check-circle-fill';
      case 'error':
        return 'bi bi-x-circle-fill';
      case 'confirm':
        return 'bi bi-question-circle-fill';
      default:
        return 'bi bi-info-circle-fill';
    }
  }

  getIconAnimationClass(): string {
    switch (this.alertConfig?.type) {
      case 'success':
        return 'animate-success';
      case 'error':
        return 'animate-error';
      case 'confirm':
        return 'animate-confirm';
      default:
        return 'animate-success';
    }
  }

  getButtonClass(): string {
    switch (this.alertConfig?.type) {
      case 'success':
        return 'btn-success';
      case 'error':
        return 'btn-danger';
      case 'confirm':
        return 'btn-warning';
      default:
        return 'btn-success';
    }
  }
}
